// extracted by mini-css-extract-plugin
export default {"result":"Receipt_result__G3yfK","img":"Receipt_img__hHv8T","title":"Receipt_title__1bjPP","text":"Receipt_text__YoaoW","btns":"Receipt_btns__1pd-u","input":"Receipt_input__Kce8f"};